import React from "react";
import { BellIcon, CloudIcon, PlusIcon, SearchIcon, SettingsIcon, StarIcon, BoxIcon } from "lucide-react";
const utilityActions = [{
  label: 'Favorites',
  icon: StarIcon
}, {
  label: 'Global Actions',
  icon: PlusIcon
}, {
  label: 'Help',
  icon: BoxIcon
}, {
  label: 'Setup',
  icon: SettingsIcon
}, {
  label: 'Notifications',
  icon: BellIcon
}];
export function GlobalHeader() {
  return <header className="flex h-12 items-center gap-4 border-b border-sf-border bg-white px-4" data-id="element-811" data-mp="xya3856dwjxz">
      <div className="flex w-[240px] items-center gap-2" data-id="element-812" data-mp="t6i8rjk3xu2k">
        <span className="flex h-8 w-11 items-center justify-center rounded bg-sf-blue" aria-hidden="true" data-id="element-813" data-mp="t4xdtstvs946">
          <CloudIcon className="h-5 w-5 text-white" fill="currentColor" data-id="element-814" data-mp="p3c24at320vk" />
        </span>
        <span className="text-sm font-bold" data-id="element-815" data-mp="k86ijin5kyan">LendingForce</span>
      </div>
      <div className="flex flex-1 justify-center" data-id="element-816" data-mp="f5xqcoi3u09l">
        <label className="relative w-full max-w-[560px]" data-id="element-817" data-mp="a85w3ntzm228">
          <span className="sr-only" data-id="element-818" data-mp="a8pgrcb0v4jy">Search</span>
          <SearchIcon className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-sf-weak" aria-hidden="true" data-id="element-819" data-mp="2mld324ahxczl" />
          <input type="search" placeholder="Search Loans, Comp Plans, Commission Periods…" className="h-8 w-full rounded border border-sf-border-strong bg-white pl-8 pr-3 text-[13px] placeholder:text-sf-weak focus:border-sf-blue focus:outline-none focus:ring-1 focus:ring-sf-blue" data-id="element-820" data-mp="2rclcv1fqn0da" />
        </label>
      </div>
      <div className="flex w-[240px] items-center justify-end gap-0.5" data-id="element-821" data-mp="35c484tngah86">
        {utilityActions.map(({
        label,
        icon: Icon
      }) => <button key={label} type="button" aria-label={label} title={label} className="flex h-8 w-8 items-center justify-center rounded text-sf-weak transition-colors duration-150 ease-out hover:bg-sf-bg hover:text-sf-text" data-id="element-822" data-mp="2vdeytp9me53j">
            <Icon className="h-[18px] w-[18px]" data-id="element-823" data-mp="1jxyp4qweideg" />
          </button>)}
        <span className="ml-2 flex h-8 w-8 items-center justify-center rounded-full bg-sf-blue-dark text-xs font-semibold text-white" role="img" aria-label="Signed in as Marvin Yaldo" data-id="element-824" data-mp="1oxbebiaqvwk7">
          MY
        </span>
      </div>
    </header>;
}